import type { Car, NavigateCar } from '../../../../_types/Car';
import stringToSlug from '../../../../utils/string-to-slug';
import checkUndefinedNullOrEmpty from '../../../../utils/tools/checkUndefinedNullOrEmpty';

export default async function handleCarNavigateData(car: Car<true>): Promise<NavigateCar> {
    if (checkUndefinedNullOrEmpty(car)) {
        return undefined;
    } else {
        return {
            hersteller: car?.hersteller,
            id: car?.id,
            loc: {
                alias: car?.loc?.alias,
                firmaName: car?.loc?.firmaName,
                hm: car?.loc?.hm,
                id: car?.loc?.id,
                image: car?.loc?.image,
                mail: car?.loc?.mail,
                name: car?.loc?.name,
                openMo: car?.loc?.openMo,
                openDi: car?.loc?.openDi,
                openMi: car?.loc?.openMi,
                openDo: car?.loc?.openDo,
                openFr: car?.loc?.openFr,
                openSa: car?.loc?.openSa,
                openSo: car?.loc?.openSo,
                openServiceMo: car?.loc?.openServiceMo,
                openServiceDi: car?.loc?.openServiceDi,
                openServiceMi: car?.loc?.openServiceMi,
                openServiceDo: car?.loc?.openServiceDo,
                openServiceFr: car?.loc?.openServiceFr,
                openServiceSa: car?.loc?.openServiceSa,
                openServiceSo: car?.loc?.openServiceSo,
                openWerkstattMo: car?.loc?.openWerkstattMo,
                openWerkstattDi: car?.loc?.openWerkstattDi,
                openWerkstattMi: car?.loc?.openWerkstattMi,
                openWerkstattDo: car?.loc?.openWerkstattDo,
                openWerkstattFr: car?.loc?.openWerkstattFr,
                openWerkstattSa: car?.loc?.openWerkstattSa,
                openWerkstattSo: car?.loc?.openWerkstattSo,
                ort: car?.loc?.ort,
                plz: car?.loc?.plz,
                str: car?.loc?.str,
                tel: car?.loc?.tel,
                tel_hpt: car?.loc?.tel_hpt,
            },
            modell: car?.modell,
            name: car?.name,
            nameSlug: stringToSlug(car?.name),
            typ: car?.typ,
        };
    }
}
